import React from 'react'
import Modal from 'react-bootstrap/Modal'

const MahalleModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={32}
      aria-labelledby='contained-modal-title-vcenter'
      //   backdrop='static'
      centered
    >
      <Modal.Body className='mahalleModal'>
        {props?.mahalleler?.map((item) => (
          <div
            className='ilceItem'
            key={item.id}
            onClick={() => {
              props.setMahalleAdi(item.adi)
              props.setMahalleid(item.id)
              props.setMahalleClass()
              props.onHide()
            }}
          >
            {item.adi}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={props.onHide}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default MahalleModal
